import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./linktree.css";

import { FaInstagram, FaLinkedinIn, FaFacebookF } from "react-icons/fa6";
import maelcorp from "../../assets/img/linktree/logo/maelcorp.svg";
import bpm from "../../assets/img/linktree/logo/bpm.svg";
import smooss from "../../assets/img/linktree/logo/smooss.svg";

const companies = [
  {
    name: "MAELCORP",
    tagline: "Votre agence de communication digitale 360°",
    color: "#25054A",
    textColor: "#FFFFFF",
    buttonsColor: "#FFFFFF",
    link: "https://maelcorp.com/",
    collab: "tel:+33493410508",
    socials: [
      { type: "instagram", url: "https://www.instagram.com/maelcorporation/" },
      { type: "linkedin", url: "https://fr.linkedin.com/company/maelcorp" }, // <-- exemple d'un autre logo
    ],
    image: require("../../assets/img/linktree/image/maelcorp.webp"),
    logo: maelcorp,
  },
  {
    name: "BPM EVENTS",
    tagline: "Music live & évènementielle",
    color: "#EBEBEB",
    textColor: "#3F3D3D",
    buttonsColor: "#3F3D3D",
    link: "https://www.bpm-events.fr/",
    collab: "tel:+33603046501",
    socials: [
      { type: "instagram", url: "https://www.instagram.com/orchestre.bpm/" },
      { type: "facebook", url: "https://www.facebook.com/orchestrebpm" }, // <-- exemple d'un autre logo
    ],
    image: require("../../assets/img/linktree/image/bpm.webp"),
    logo: bpm,
  },
  {
    name: "SMOOSS'",
    tagline: "Votre partenaire en detailing automobile",
    color: "#3E3E3E",
    textColor: "#DFBB74",
    buttonsColor: "#DFBB74",
    link: "https://www.smooss.fr/",
    collab: "tel:+33981547365",
    socials: [
      { type: "instagram", url: "https://www.instagram.com/smooss__/" },
      {
        type: "linkedin",
        url: "https://fr.linkedin.com/company/smooss-nettoyage-de-vehicule",
      }, // <-- exemple d'un autre logo
    ],
    image: require("../../assets/img/linktree/image/smooss.webp"),
    logo: smooss,
  },
];

const iconMap = {
  instagram: <FaInstagram className="social-icon" />,
  linkedin: <FaLinkedinIn className="social-icon" />,
  facebook: <FaFacebookF className="social-icon" />,
};

export default function LinktreeSlider() {
  const [index, setIndex] = useState(0);

  // Slider uniquement en desktop
  useEffect(() => {
    if (window.innerWidth >= 900) {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % companies.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, []);

  const company = companies[index];

  return (
    <>
      {/* VERSION DESKTOP (SLIDER) */}
      <div
        className="slider-container desktop"
        style={{ backgroundColor: company.color }}
      >
        <div className="left-content" style={{ color: company.textColor }}>
          <article className="top-part">
            <div className="logo-container">
              <img src={company.logo} alt={company.name} className="logo" />
            </div>
            <p>{company.tagline}</p>
          </article>
          <div className="bottom-part">
            <a
              className="website-link"
              href={company.collab}
              target="_blank"
              style={{
                color: company.color,
                backgroundColor: company.buttonsColor,
              }}
            >
              COLLAB'
            </a>
            <a
              className="website-link"
              href={company.link}
              target="_blank"
              style={{
                color: company.color,
                backgroundColor: company.buttonsColor,
              }}
            >
              WEB SITE
            </a>
            <div className="socials">
              {company.socials.map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  target="_blank"
                  style={{ color: company.textColor }}
                >
                  {iconMap[social.type] || null}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="right-content">
          <AnimatePresence mode="wait">
            <motion.img
              key={company.image}
              src={company.image}
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 50, opacity: 0 }}
              transition={{ duration: 0.8 }}
              alt={company.name}
            />
          </AnimatePresence>
        </div>
      </div>

      {/* VERSION MOBILE (STACK) */}
      <div className="mobile">
        {companies.map((c, idx) => (
          <div
            key={idx}
            className="mobile-card"
            style={{ backgroundColor: c.color, color: c.textColor }}
          >
            <div className="logo-container">
              <img src={c.logo} alt={c.name} className="logo" />
            </div>
            <p>{c.tagline}</p>
            <a
              className="website-link"
              href={c.collab}
              target="_blank"
              style={{ color: c.color, backgroundColor: c.buttonsColor }}
            >
              COLLAB'
            </a>
            <a
              className="website-link"
              href={c.link}
              target="_blank"
              style={{ color: c.color, backgroundColor: c.buttonsColor }}
            >
              WEB SITE
            </a>
            <div className="socials">
              {c.socials.map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  target="_blank"
                  style={{ color: c.textColor }}
                >
                  {iconMap[social.type] || null}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
